/**
 * Single source of truth for product naming (spec §1).
 * Domain/trademark verification pending — any rename is a one-line edit here.
 */
export const BRAND = {
  name: 'CueForge',
  tagline: 'Subtitle conversion, repair & QC — 100% in your browser.',
  licensePrefix: 'CFRG',
} as const;

export type Brand = typeof BRAND;
